import {Button, Offcanvas} from 'react-bootstrap'
import {LeadByID} from '../../leadTypes'
import {useQuery} from '@apollo/client'
import {GET_ALL_SIGNATURE_FORMS_ENTRIES_API} from '../../../../gql/queries/signatureFormsEntriesApiQueries'
import {useDisclourse} from '../../../../hooks/useDisclourse'
import {ModalRequestSignature} from '../../../signatureForms/components/ModalRequestSignature'
import {SignatureFormsEntriesTimeline} from '../../../signatureFormsEntries/components/SignatureFormsEntriesTimeline'
import {useEffect} from 'react'
import {toast} from 'react-toastify'
import {IResSignatureFormsEntriesAPI} from '../../../../types/signatureFormsEntriesApi'
import {LeadSummaryPanel} from '../LeadSummaryPanel'

interface IReqConsProps {
  lead: LeadByID
  children: JSX.Element
  emptyMessage?: string
}

export const RequesConsentDrawer: React.FC<IReqConsProps> = ({lead, children}) => {
  const {
    data: dataEntriesByLead,
    error,
    loading,
    refetch: refetchEntries,
  } = useQuery<IResSignatureFormsEntriesAPI>(GET_ALL_SIGNATURE_FORMS_ENTRIES_API, {
    variables: {lead: lead.id},
    fetchPolicy: 'network-only', // para que siempre consulte desde el servidor
  })

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])
  const {isOpen, onClose, onOpen} = useDisclourse()

  const hasEmail = !!lead.email
  const hasPhone = !!lead.phone
  console.log('RCD hasEmail:' + hasEmail + ' hasPhone:' + hasPhone)

  return (
    <>
      <Offcanvas.Header closeButton className='bg-light'>
        <div className='d-flex align-items-center justify-content-between w-100'>
          <Offcanvas.Title className='d-flex align-items-center gap-4'>
            Consent Requests
          </Offcanvas.Title>
          <Button size='sm' onClick={onOpen} variant='info'>
            <i className='bi bi-vector-pen fs-4' />
            Request Consent
          </Button>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {children}
        <div className='lead-summary-layout'>
          <div className='lead-summary lead-summary-sticky'>
            <LeadSummaryPanel lead={lead} />
          </div>
          <div className='lead-summary-content'>
            <div className='mt-6'>
              <SignatureFormsEntriesTimeline
                loading={loading}
                dataEntriesByLead={dataEntriesByLead?.allSignatureFormsEntries}
                refetch={refetchEntries}
                hasEmail={hasEmail}
                hasPhone={hasPhone}
              />
            </div>
          </div>
        </div>
      </Offcanvas.Body>
      {isOpen && (
        <ModalRequestSignature
          keyboard={false}
          backdrop='static'
          isOpen={isOpen}
          sourceId={lead.id}
          sourceType='lead'
          onClose={onClose}
          refetch={refetchEntries}
          hasEmail={hasEmail}
          hasPhone={hasPhone}
        />
      )}
    </>
  )
}
